// app/javascript/entrypoints/application.js
// jQueryをグローバルな値として使えるように設定
// CKEditorのプラグイン(imagecrop)の動作に関連。
import $ from "jquery";
window.jQuery = $;
window.$ = $;

// To see this message, add the following to the `<head>` section in your
// views/layouts/application.html.erb
//
//    <%= vite_client_tag %>
//    <%= vite_javascript_tag 'application' %>
// Example: Load Rails libraries in Vite.
//
// import * as Turbo from '@hotwired/turbo'
// Turbo.start()
//
// import ActiveStorage from '@rails/activestorage'
// ActiveStorage.start()
//
// // Import all channels.
// const channels = import.meta.glob('./**/*_channel.js', { eager: true })

// Example: Import a stylesheet in app/frontend/index.css
// import '~/index.css'

// 3. react_ujs の設定 (ここが重要です)
import ReactRailsUJS from "react_ujs";

console.log("Vite ⚡️ Rails");

// If using a TypeScript entrypoint file:
//     <%= vite_typescript_tag 'application' %>
//
// If you want to use .jsx or .tsx, add the extension:
//     <%= vite_javascript_tag 'application.jsx' %>

console.log(
  "Visit the guide for more information: ",
  "https://vite-ruby.netlify.app/guide/rails",
);

// Vite の glob import を使ってコンポーネントを一括取得
// '~/components' は vite.config.ts で設定したエイリアス、
// または相対パス '../../components' などに合わせてください。
const components = import.meta.glob("~/components/**/*.{jsx,tsx}", {
  eager: true,
});

// react_ujs がコンポーネントを見つけられるようにマッピング関数を定義
ReactRailsUJS.getConstructor = (name) => {
  // コンポーネント名からファイルパスを解決
  // 例: 'UserAvatar' -> '~/components/UserAvatar.jsx'
  const path = Object.keys(components).find((key) => key.includes(`/${name}.`));
  if (!path) {
    console.error(
      `Component ${name} not found in glob:`,
      Object.keys(components),
    );
    return null;
  }
  // 拡張子が .jsx なら .default 、TypeScript ならそのままと使い分ける場合があります
  return components[path].default || components[path];
};

// 初期化（Railsのページ遷移に合わせてマウント/アンマウントを管理）
ReactRailsUJS.handleEvent("DOMContentLoaded", ReactRailsUJS.mountComponents);
// Turbo を使っている場合はこちらも必要
// ReactRailsUJS.handleEvent('turbo:load', ReactRailsUJS.mountComponents)
// ReactRailsUJS.handleEvent('turbo:before-render', ReactRailsUJS.unmountComponents)
